import { z } from "zod/v4";
import { rankingListSyncSchema, scrapeRunSchema, scraperSourceSchema } from "../schemas/athlete";
import { fetchApi } from "./internal";

export const scraper = {
	listSources: () => fetchApi("/admin/athletes/sources", z.array(scraperSourceSchema)),
	triggerRun: (source: string) =>
		fetchApi("/admin/athletes/runs", z.object({ id: z.string() }), {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ source }),
		}),
	listRuns: () => fetchApi("/admin/athletes/runs", z.array(scrapeRunSchema)),
	listSyncs: () => fetchApi("/admin/athletes/syncs", z.array(rankingListSyncSchema)),
};
